import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
`;

export const Content = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
`;
export const MobileButtonContainer = styled.div`
  ${({ theme }) =>
    !theme.isMobile &&
    css`
      display: none;
    `};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
